/*eslint-disable*/
import React, { useState, useEffect } from "react";

// components
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from "@mui/material";

// hooks
import usePreviousSearchText from "../../../../hooks/usePreviousSearchText"
import { useTranslation } from "react-i18next"

const SearchBar = ({ searchText, setSearchText, getBulkUploadStatuses }) => {

  const { previousSearchText, setPreviousSearchText } = usePreviousSearchText(searchText);
  const { t } = useTranslation()
  const handleSearch = (e) => {
    const { value } = e?.target;
    setSearchText(value)
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && searchText !== previousSearchText) {
      setPreviousSearchText(searchText);
      getBulkUploadStatuses();
    }
  }

  return (
    <div
      style={{ height: "95px", marginBottom: "20px", backgroundColor: "#f5f5f5", width: "100vw", display: "flex", justifyContent: "center", alignItems: "center" }}
    >
      <TextField
        placeholder={t('bulk-search-bar-placeholder')}
        value={searchText}
        size="small"
        onChange={handleSearch}
        onKeyDown={handleKeyDown}
        InputProps={{
          startAdornment: (
            <SearchIcon sx={{ color: "action.active", marginRight: 1 }} />
          ),
          endAdornment: searchText?.length > 0 && (
            <IconButton onClick={() => setSearchText('')}>
              <CloseIcon />
            </IconButton>
          )
        }}
        sx={{
          width: "950px",
          borderRadius: "20px",
          padding: "10px",
          boxShadow: "20px 20px 40px 0px #0000001A",
          border: "0px 0px 1px 0px",
          gap: "10px",
          backgroundColor: 'white',
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none', // Remove the border
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            border: 'none', // Remove the border on hover
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: 'none', // Remove the border when focused
          },
        }}
      />
    </div>
  );
};

export default SearchBar;
